<template>
    <div class="query-record">
        <el-card class="box-card flex-1 marginT-20">
            <div slot="header" class="flex flex-between">
                <span class="fw-bold fc-333">关键词卡首屏记录</span>
            </div>
            <div>
                <div class="table">
                    <el-table :data="tableData" border>
                        <el-table-column prop="result_data.password" label="生成方式">
                            <template slot-scope="scope">
                                <span>{{scope.row.result_data.password ? '淘口令' : '二维码'}}</span>
                                <el-button style='margin-left: 6px;' type='text' v-show='!scope.row.result_data.password' @click="lookQrCode(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="result_data.password" label="生成内容">
                            <template slot-scope="scope">
                                <div v-if="scope.row.result_data.password">{{scope.row.result_data.password}}</div>
                                <el-popover v-else trigger="hover" placement="top">
                                    <p>{{ scope.row.result_data.link || '--'}}
                                    </p>
                                    <div slot="reference"
                                        class="name-wrapper">
                                        {{ scope.row.result_data.link || '--'}}
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(item, index) in selCol" :key="item" :prop="`result_data.${item}`" :label="index">
                            <template slot-scope="scope">
                                <el-popover v-if="index == '商品链接(商品ID)'" trigger="hover" placement="top">
                                    <p>{{ scope.row.result_data[item] || '--'}}
                                    </p>
                                    <div slot="reference"
                                        class="name-wrapper">
                                        {{ scope.row.result_data[item] || '--'}}
                                    </div>
                                </el-popover>
                                <div v-else>{{scope.row.result_data[item]}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="完成时间" :formatter="row => dateFormatUtils(row.created_at * 1000)"></el-table-column>
                    </el-table>
                </div>
                <div class="pages marginT-20 text-center">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import pagination from '@/index/mixin/pagination'
export default {
    mixins: [pagination],
    props: ['method'],

    data() {
        return {
            searchForm: {
                invokeName: this.method,
                psize: 5,
            },
            selCol: {
                '搜索关键词': 'content',
                '商品链接(商品ID)': 'url'
            },
            tableData: [],
            tableUrl: '/tool/accounts/invoke-log',
        }
    },
    methods: {
        lookQrCode(row) {
            this.$message.warning("二维码不存在或已过期")
            // window.showQrCode(row.result_data.link);
        },
    },
    mounted() {
        if (localStorage.token) {
            this.init()
        }

    },
    watch: {
        method(newValue, _) {
            if (newValue) {
                this.tableData = [];
                this.searchForm.invokeName = newValue;
                this.init();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
